<template>
  <SettingsMediaUpload
    prop="portrait_cover"
    section="images"
    :label="$t('_web_competitions_portrait-label', 'Portrait BG:')"
    :tooltip="
      $$t(
        'Portrait is used as a tournament profile background',
        'portrait-tooltip'
      )
    "
    :width="3"
    :height="4"
    :recommended-width="720"
    :recommended-height="1080"
  />
</template>

<script>
import SettingsMediaUpload from '@/views/tournaments/management/singleTournament/components/SettingsMediaUpload';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentPortraitCoverSetting',
  components: {
    SettingsMediaUpload,
  },
  mixins: [translate('_web_tournament_settings')],
};
</script>
